import { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { dotPath, isNilOrEmpty, isUndefined } from 'ramdasauce'
import { Link } from 'gatsby'
import cn from 'classnames'

import { useStyles } from './styles'
import { StoreContext } from 'context'
import { Text, RichText } from 'components/atoms'
import { ProductImages } from 'components/molecules'
import { ROUTES } from 'utils/constants'

export const ProductDetails = ({ data }) => {
  const classes = useStyles()

  const [quantity, setQuantity] = useState(1)
  const [activeVariant, setActiveVariant] = useState()
  const [addingToCart, setAddingToCart] = useState(undefined)

  const totalInventory = dotPath('productData.totalInventory', data)
  const initialPriceRange = dotPath('productData.priceRangeV2', data)
  const shopifyVariants = dotPath('productData.variants', data)
  const variants = dotPath('variants', data)

  const { addVariantToCart } = useContext(StoreContext)

  const maxPrice = dotPath('maxVariantPrice.amount', initialPriceRange)
  const minPrice = dotPath('minVariantPrice.amount', initialPriceRange)
  const price =
    maxPrice === minPrice ? `$${maxPrice}0` : `$${maxPrice}0 - $${minPrice}0`

  const decreaseQuantity = () =>
    quantity === 1 ? quantity : setQuantity(quantity - 1)
  const increaseQuantity = () =>
    quantity === totalInventory ? quantity : setQuantity(quantity + 1)

  const renderVariants = (variants) => {
    return variants.map((variant) => {
      const buttonClasses = cn({
        [classes.variantButton]: true,
        [classes.activeVariant]:
          variant.variant === dotPath('storefrontId', activeVariant),
      })

      return (
        <button
          className={buttonClasses}
          onClick={() =>
            setActiveVariant({
              title: variant.title,
              storefrontId: variant.variant,
            })
          }
          key={variant.id}
        >
          <Text size="label3">{variant.title}</Text>
        </button>
      )
    })
  }

  const handleAddToCart = () => {
    const variant = !isNilOrEmpty(activeVariant)
      ? activeVariant.storefrontId
      : dotPath('shopifyProduct', data)
    if (!isNilOrEmpty(variant)) {
      setAddingToCart(true)
      addVariantToCart(variant, quantity)

      setTimeout(() => {
        setAddingToCart(false)
      }, [500])
    }
  }

  const addToCartText = addingToCart ? 'Adding to cart' : 'Added to cart!'
  const disableAddToCart = !isNilOrEmpty(variants)
    ? isNilOrEmpty(activeVariant)
    : false

  return (
    <div className={classes.wrapper}>
      <div className={classes.productContainer}>
        {!isNilOrEmpty(dotPath('productImages', data)) && (
          <ProductImages images={dotPath('productImages', data)} />
        )}
        <div className={classes.textBlock}>
          {!isNilOrEmpty(dotPath('title', data)) && (
            <Text size="header1" className={classes.title} tag="h1">
              {dotPath('title', data)}
            </Text>
          )}
          <Text size="body5" className={classes.price} tag="p">
            {price}
          </Text>
          <div className={classes.orderSelectors}>
            <div>
              <Text size="label5" className={classes.quantityTitle}>
                QUANTITY
              </Text>
              <div className={classes.quantitySelectors}>
                <button
                  onClick={decreaseQuantity}
                  className={classes.quantityButton}
                >
                  <Text size="body5">-</Text>
                </button>
                <div className={classes.quantity}>
                  <Text size="label5" tag="p">
                    {quantity}
                  </Text>
                </div>
                <button
                  className={classes.quantityButton}
                  onClick={increaseQuantity}
                >
                  <Text size="body5">+</Text>
                </button>
              </div>
            </div>
            {!isNilOrEmpty(variants) && (
              <div className={classes.variantSelectors}>
                <Text className={classes.variantTitle} size="label5">
                  {shopifyVariants[0].selectedOptions[0].name}
                </Text>
                <div className={classes.quantitySelectors}>
                  {renderVariants(variants)}
                </div>
              </div>
            )}
          </div>
          <button
            disabled={disableAddToCart}
            onClick={handleAddToCart}
            className={classes.addToCart}
          >
            {isUndefined(addingToCart) ? 'Add to cart' : addToCartText}
          </button>
          {!isUndefined(addingToCart) && !addingToCart && (
            <Text size="body6" className={classes.successMessage} tag="p">
              View <Link to={ROUTES.CART}>cart</Link> or{' '}
              <Link to={ROUTES.SHOP}>keep shopping</Link>.
            </Text>
          )}
          {!isNilOrEmpty(data.productDescription) && (
            <>
              {' '}
              <Text size="label5" tag="p" className={classes.details}>
                PRODUCT DETAILS
              </Text>
              <Text>
                <Text size="body6" className={classes.description}>
                  <RichText data={dotPath('productDescription', data)} />
                </Text>
              </Text>
            </>
          )}
        </div>
      </div>
      <div className={classes.backLinkWrapper}>
        <Link to={ROUTES.SHOP} className={classes.backLink}>
          <Text size="label5">Back to Merch</Text>
        </Link>
      </div>
    </div>
  )
}

ProductDetails.propTypes = {
  data: PropTypes.object,
}

ProductDetails.defaultProps = {
  data: null,
}
